import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ACTIONS_PER_PAGE } from "@/api/graphql/actions/constants.ts";
import type { Agent } from "@/api/graphql/actions/types.ts";
import { useGetActionsByUser } from "@/api/graphql/actions/user/hooks.ts";
import { StyledIdentity } from "@/components/Users/details/styles.ts";
const getUserName = (agent: Agent) =>
  agent?.firstName + " " + agent.lastName || "N F";

export const useActionTableData = (userId: string) => {
  const { t: tActions } = useTranslation("actions");
  const {
    actions,
    isActionsLoading,
    totalActions,
    hasNextPage,
    fetchNextPage,
  } = useGetActionsByUser({ pageSize: ACTIONS_PER_PAGE, userId });
  const columns = useMemo(
    () => [
      {
        identifier: "date",
        columnName: tActions("actions.table.body.columns.date"),
        displayedByDefault: true,
      },
      {
        identifier: "time",
        columnName: tActions("actions.table.body.columns.time"),
        displayedByDefault: true,
      },
      {
        identifier: "action",
        columnName: tActions("actions.table.body.columns.action"),
        displayedByDefault: true,
      },
      {
        identifier: "agent",
        columnName: tActions("actions.table.body.columns.agent"),
        displayedByDefault: true,
      },
    ],
    [tActions],
  );
  const rows = useMemo(() => {
    if (!actions) return [];

    return actions.map((action) => ({
      data: {
        date: action.date,
        time: action.time,
        action: action.name,
        agent: (
          <StyledIdentity
            avatar={{
              firstName: action.agent.firstName,
              lastName: action.agent.lastName,
              type: "initials",
            }}
            subtitle={action.agent.igg}
            title={getUserName(action.agent)}
          />
        ),
      },
      id: action.id,
      key: action.id,
    }));
  }, [actions]);

  return {
    columns,
    rows,
    totalActions,
    isActionsLoading,
    hasNextPage,
    fetchNextPage,
  };
};
